"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var BottomDrawer_1 = __importDefault(require("../../../../../app/components/widgets/BottomDrawer"));
var SortPanel_1 = __importDefault(require("../../../../../app/components/widgets/SortPanel"));
var FilterPanel_1 = __importDefault(require("./FilterPanel"));
var FilterSortPanelFooter_1 = __importDefault(require("./FilterSortPanelFooter"));
var CollapsingPanel_1 = __importDefault(require("../../../../../app/components/widgets/CollapsingPanel"));
var constants_1 = require("../../../../constants");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        titleText: (_a = {
                fontSize: '0.8125rem',
                fontWeight: 500,
                paddingLeft: theme.spacing(4)
            },
            _a[theme.breakpoints.up('md')] = {
                color: '#767676',
            },
            _a[theme.breakpoints.down('sm')] = {
                paddingTop: theme.spacing(2),
            },
            _a),
        divider: {
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(0.5),
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spacing(3.5),
            marginBottom: theme.spacing(3.5),
            zIndex: 3,
        },
        sortPanel: {
            width: theme.spacing(50),
            right: 0,
            left: 'auto',
        },
    });
});
/**
 * @component Holds the panel for sorting configuration and filter configuration based on state and type.
 */
var SortDrawer = function (_a) {
    var open = _a.open, onClose = _a.onClose, options = _a.options, onChoose = _a.onChoose, getFile = _a.getFile, getState = _a.getState, onApply = _a.onApply, onReset = _a.onReset;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var _b = __read(react_1.useState(constants_1.defaultSortOption), 2), orderBy = _b[0], setOrderBy = _b[1];
    var _c = __read(react_1.useState(false), 2), isIncludeFiles = _c[0], setIsIncludeFiles = _c[1];
    var _d = __read(react_1.useState(false), 2), isIncludeLinks = _d[0], setIsIncludeLinks = _d[1];
    var _e = __read(react_1.useState(false), 2), isIncludeActive = _e[0], setIsIncludeActive = _e[1];
    var _f = __read(react_1.useState(false), 2), isIncludeInactive = _f[0], setIsIncludeInactive = _f[1];
    // Order check
    react_1.useEffect(function () {
        onChoose(orderBy);
    }, [orderBy]);
    // File check
    react_1.useEffect(function () {
        if (isIncludeFiles === isIncludeLinks) {
            getFile('');
        }
        else if (isIncludeFiles) {
            getFile('true');
        }
        else {
            getFile('false');
        }
    }, [isIncludeFiles, isIncludeLinks]);
    // State check
    react_1.useEffect(function () {
        if (isIncludeActive === isIncludeInactive) {
            getState('');
        }
        else if (isIncludeActive) {
            getState('ACTIVE');
        }
        else {
            getState('INACTIVE');
        }
    }, [isIncludeActive, isIncludeInactive]);
    // Close the modal and hit endpoint
    var applyChange = function () {
        onClose();
        onApply();
    };
    var reset = function () {
        // reset current component's state
        setOrderBy(constants_1.defaultSortOption);
        setIsIncludeFiles(false);
        setIsIncludeLinks(false);
        setIsIncludeActive(false);
        setIsIncludeInactive(false);
        // reset to initial config
        onClose();
        onReset();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isMobile ? (react_1.default.createElement(BottomDrawer_1.default, { open: open, onClose: onClose },
        react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(SortPanel_1.default, { onChoose: setOrderBy, currentlyChosen: orderBy, options: options }),
            react_1.default.createElement(FilterPanel_1.default, { isIncludeFiles: isIncludeFiles, isIncludeLinks: isIncludeLinks, isIncludeActive: isIncludeActive, isIncludeInactive: isIncludeInactive, setIsIncludeFiles: setIsIncludeFiles, setIsIncludeLinks: setIsIncludeLinks, setIsIncludeActive: setIsIncludeActive, setIsIncludeInactive: setIsIncludeInactive }),
            react_1.default.createElement(FilterSortPanelFooter_1.default, { onApply: applyChange, onReset: reset })))) : (react_1.default.createElement(CollapsingPanel_1.default, { isOpen: open, className: classes.sortPanel },
        react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(SortPanel_1.default, { onChoose: setOrderBy, currentlyChosen: orderBy, options: options }),
            react_1.default.createElement(FilterPanel_1.default, { isIncludeFiles: isIncludeFiles, isIncludeLinks: isIncludeLinks, isIncludeActive: isIncludeActive, isIncludeInactive: isIncludeInactive, setIsIncludeFiles: setIsIncludeFiles, setIsIncludeLinks: setIsIncludeLinks, setIsIncludeActive: setIsIncludeActive, setIsIncludeInactive: setIsIncludeInactive }),
            react_1.default.createElement(FilterSortPanelFooter_1.default, { onApply: applyChange, onReset: reset }))))));
};
exports.default = SortDrawer;
